import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _60d8c63e = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _91f2bce8 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _1c88b84c = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _c49f5982 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _ffe7ae0a = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _5cb7045c = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _07729368 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _520e65b4 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _06be46ee = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _359839b8 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _06e6a8d9 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _d768dece = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _d6693f78 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _1725f94a = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _7846fc04 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _84aefc1e = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _a64926ae = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _ce09ffb8 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _60d8c63e,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _91f2bce8,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _1c88b84c,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _c49f5982,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _ffe7ae0a,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _5cb7045c,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _5cb7045c,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _5cb7045c,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _07729368,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _520e65b4,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _06be46ee,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _520e65b4,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _06be46ee,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _359839b8,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _359839b8,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _359839b8,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _359839b8,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _359839b8,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _359839b8,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _359839b8,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _06e6a8d9,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _06e6a8d9,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _d768dece,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _d6693f78,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _d6693f78,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _1725f94a,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _7846fc04,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _84aefc1e,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _84aefc1e,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _a64926ae,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _ce09ffb8,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
